import * as React from 'react';

// Material-UI
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';

import RequestSummary from './RequestSummary';

// Styles
import { useTheme } from '@mui/material/styles';

import {
  MATERIALUI_DIALOG_REASON_BACKDROPCLICK,
  MATERIALUI_DIALOG_REASON_ESCKEYDOWN,
} from '../../global';

interface RequestSummaryDialogProps {
  handleClose: () => void;
  id: number;
  show: boolean;
}

const RequestSummaryDialog: React.FC<RequestSummaryDialogProps> = (props) => {

  // #region Styles

  const theme = useTheme();
  const styles = {
    closeButton: {
      margin: theme.spacing(0, 1, 1, 0)
    },
    reported: {
      margin: theme.spacing(0, 0, 1, 0)
    },
    rowSpacing: {
      margin: theme.spacing(1, 0, 0, 0)
    },
    title: {
      margin: theme.spacing(0, 0, 1, 0)
    },
  };

  // #endregion

  // #region Event handlers

  /*
* Event handler for Material-UI onClose
*/
  const handleClose = (event: object, reason: string) => {
    if ((reason === MATERIALUI_DIALOG_REASON_BACKDROPCLICK) || (reason === MATERIALUI_DIALOG_REASON_ESCKEYDOWN)) {
      return;
    }
  };

  // #endregion

  return (
    <Dialog
      open={props.show}
      onClose={handleClose}
      disableEscapeKeyDown={true}
      fullWidth={true}
      maxWidth="sm"
    >
      <DialogContent>
        <RequestSummary
          id={props.id}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={props.handleClose} variant="outlined" color="primary" sx={styles.closeButton}>Close</Button>
      </DialogActions>
    </Dialog >
  );

}

export default RequestSummaryDialog;